import type { TableConfig } from '../types';

export interface LayoutConfig {
  tables: TableConfig[];
  seatRadius: number;
  seatTextOffset: number;
  rectangleWidth: number;
  rectangleHeight6: number;
  rectangleHeight7: number;
}

// Layout constants - change these to adjust spacing
const RECT_WIDTH = 100;
const RECT_HEIGHT = 200;  // Both 6-seat and 7-seat use same height
const HORIZONTAL_SPACING = 100;  // Gap between columns
const VERTICAL_SPACING = 30;     // Gap between tables in a column
const START_X = 200;             // Left margin
const START_Y = 150;             // Top margin

// Calculate column X positions based on table width and spacing
const COL_1_X = START_X;
const COL_2_X = COL_1_X + RECT_WIDTH + HORIZONTAL_SPACING;
const COL_3_X = COL_2_X + RECT_WIDTH + HORIZONTAL_SPACING;
const COL_4_X = COL_3_X + RECT_WIDTH + HORIZONTAL_SPACING;
const COL_5_X = COL_4_X + RECT_WIDTH + HORIZONTAL_SPACING;

// Helper to calculate Y position for table in a column
const getY = (row: number) => START_Y + row * (RECT_HEIGHT + VERTICAL_SPACING);

// New layout with 18 rectangle tables (matching the image)
// All tables have same dimensions (80x200), but 6-seat vs 7-seat differs only by top seat
export const defaultLayout: LayoutConfig = {
  seatRadius: 22,
  seatTextOffset: 8,
  rectangleWidth: RECT_WIDTH,
  rectangleHeight6: RECT_HEIGHT,
  rectangleHeight7: RECT_HEIGHT,
  tables: [
    // Column 1 (leftmost): Tables 18, 17, 16, 15
    { tableNumber: 18, type: 'rectangle_7', x: COL_1_X, y: getY(0) },
    { tableNumber: 17, type: 'rectangle_6', x: COL_1_X, y: getY(1) },
    { tableNumber: 16, type: 'rectangle_6', x: COL_1_X, y: getY(2) },
    { tableNumber: 15, type: 'rectangle_6', x: COL_1_X, y: getY(3) },
    
    // Column 2: Tables 14, 13, 12, 11
    { tableNumber: 14, type: 'rectangle_7', x: COL_2_X, y: getY(0) },
    { tableNumber: 13, type: 'rectangle_6', x: COL_2_X, y: getY(1) },
    { tableNumber: 12, type: 'rectangle_6', x: COL_2_X, y: getY(2) },
    { tableNumber: 11, type: 'rectangle_6', x: COL_2_X, y: getY(3) },
    
    // Column 3 (center): Tables 10, 9 (starts lower, only 2 tables)
    { tableNumber: 10, type: 'rectangle_6', x: COL_3_X, y: getY(1.3) },
    { tableNumber: 9, type: 'rectangle_6', x: COL_3_X, y: getY(2.3) },
    
    // Column 4: Tables 8, 7, 6, 5
    { tableNumber: 8, type: 'rectangle_7', x: COL_4_X, y: getY(0) },
    { tableNumber: 7, type: 'rectangle_6', x: COL_4_X, y: getY(1) },
    { tableNumber: 6, type: 'rectangle_6', x: COL_4_X, y: getY(2) },
    { tableNumber: 5, type: 'rectangle_6', x: COL_4_X, y: getY(3) },
    
    // Column 5 (rightmost): Tables 4, 3, 2, 1
    { tableNumber: 4, type: 'rectangle_7', x: COL_5_X, y: getY(0) },
    { tableNumber: 3, type: 'rectangle_6', x: COL_5_X, y: getY(1) },
    { tableNumber: 2, type: 'rectangle_6', x: COL_5_X, y: getY(2) },
    { tableNumber: 1, type: 'rectangle_6', x: COL_5_X, y: getY(3) },
  ]
};

// Later: read this from the current VersionState
export function getLayout(): LayoutConfig {
  return defaultLayout;
}
